import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/logo-white.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      alt: "",
      class: "logo",
      src: _imports_0
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push({ name: 'Home' }))),
        class: _normalizeClass(['menu-item', _ctx.route.name === 'Home' ? 'active ' : ''])
      }, "首页", 2),
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"menu-item\"> 创作者服务 <ul class=\"popover\"><li><a href=\"https://mcn.mgtv.com/index\" target=\"_blank\">MCN机构</a></li><li><a href=\"https://creator.mgtv.com\" target=\"_blank\">个人创作者</a></li></ul></div><div class=\"menu-item\"><a href=\"https://xiaomang.mgtv.com\" target=\"_blank\">商家入驻</a></div><div class=\"menu-item\"><a href=\"http://open.shopmang.com\" target=\"_blank\">开放平台</a></div>", 3)),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push({ name: 'About' }))),
        class: _normalizeClass(['menu-item', _ctx.route.name === 'About' ? 'active ' : ''])
      }, "关于我们", 2),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "menu-item" }, [
        _createTextVNode(" 加入我们 "),
        _createElementVNode("ul", { class: "popover" }, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "https://app.mokahr.com/m/apply/xiaomang-mgtv/42363",
              target: "_blank"
            }, "社会招聘")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "https://app.mokahr.com/m/campus-recruitment/xiaomang-mgtv/42364",
              target: "_blank"
            }, "实习生招聘")
          ])
        ])
      ], -1))
    ])
  ]))
}